import React, { useState, useEffect } from 'react';
import { FiFileText } from 'react-icons/fi';
import { KPICard as UIKPICard, LoadingSpinner } from '../../ui';
import { useExecutiveTotalInvoices } from '../../../hooks/useExecutiveKPIs';

import { KPIProps } from '../../../types/kpi';
const FileTextIcon = FiFileText as React.ElementType;

const TotalInvoicesKPI: React.FC<KPIProps> = ({
  branchId = 0,
  timeRange,
  onError,
  showLoading = true,
  compact = false,
  className = ''
}) => {
  const [animatedValue, setAnimatedValue] = useState<number>(0);
  
  // Fetch invoices data
  const { data, isLoading, error } = useExecutiveTotalInvoices(branchId, timeRange as string);
  
  // Extract data
  const invoices = data?.invoices || 0;
  
  // Handle error
  React.useEffect(() => {
    if (error && onError) {
      onError(error as Error);
    }
  }, [error, onError]);
  
  // Animation for numbers
  useEffect(() => {
    if (!invoices) return;
    
    const endValue = invoices;
    const startValue = animatedValue || 0;

    const animateValue = (start: number, end: number, duration: number) => {
      if (start === end) {
        setAnimatedValue(end);
        return;
      }
      
      let startTimestamp: number | null = null;
      const step = (timestamp: number) => {
        if (!startTimestamp) startTimestamp = timestamp;
        const progress = Math.min((timestamp - startTimestamp) / duration, 1);
        const value = Math.floor(progress * (end - start) + start);
        setAnimatedValue(value);
        if (progress < 1) {
          window.requestAnimationFrame(step);
        }
      };
      window.requestAnimationFrame(step);
    };

    const timerId = setTimeout(() => {
      animateValue(startValue, endValue, 1000);
    }, 100);
    
    return () => clearTimeout(timerId);
  }, [invoices]);
  
  if (isLoading && showLoading) {
    return (
      <div className={`animate-enter animate-delay-1 ${className}`}>
        <div className="card-base card-padding">
          <div className="flex items-center justify-center h-32">
            <LoadingSpinner variant="minimal" size="md" />
          </div>
        </div>
      </div>
    );
  }
  
  return (
    <UIKPICard
      title="مجموع سفارش‌ها"
      value={animatedValue}
      subtitle="سفارش"
      variant="info"
      accentStyle="corner"
      className={`animate-enter ${className}`}
      icon={<FileTextIcon size={20} />}
    />
  );
};

export default TotalInvoicesKPI;
